import initialState from './ReportsInitialState';
import * as type from './ReportsType';
const defaultForm = {
    type: '',
    allTypes: [],
    locations: [],
    allLocations: [],
    requester: '',
    provider: '',
    reported: null,
    content: JSON.stringify({
        blocks: [
            {
                key: 'd6fp7',
                text: '',
                type: 'unstyled',
                depth: 0,
                inlineStyleRanges: [],
                entityRanges: [],
                data: {}
            }
        ],
        entityMap: {}
    }),
    images: [],
    reportId: null,
    location_names: []
};
export const reportsReducer = (state = initialState, action) => {
    switch (action.type) {
        case type.GET_PATIENT_REPORTS.SUCCESS:
            return { ...state, reports: action.payload };
        case type.DELETE_REPORT:
            return {
                ...state,
                form: { ...defaultForm, allTypes: [...state.form.allTypes] },
                reports: state.reports.filter((i) => i.id !== action.payload)
            };
        case type.UPDATE_CREATE_REPORT:
            // eslint-disable-next-line no-case-declarations
            const result = state.reports.findIndex((val) => val.id === action.id);

            if (result !== -1) {
                return {
                    // form: formToShow,
                    form: { ...defaultForm, allTypes: [...state.form.allTypes] },
                    reports: state.reports.map((i) => {
                        if (i.id === action.id) {
                            return {
                                ...i,
                                ...action.data
                            };
                        }
                        return i;
                    })
                };
            } else {
                return {
                    // form: formToShow,
                    form: { ...defaultForm, allTypes: [...state.form.allTypes] },
                    reports: [action.data, ...state.reports]
                };
            }
        case type.DELETE_IMAGE_FROM_REPORT:
            return {
                form: {
                    ...state.form,
                    ...action.updatedReport,
                    locations: [...state.form.locations]
                },
                reports: state.reports.map((i) => {
                    if (i.id === action.reportId) {
                        return {
                            ...i,
                            ...action.updatedReport
                        };
                    }
                    return i;
                })
            };
        case type.SET_ALL_TYPES:
            return {
                ...state,
                form: { ...state.form, allTypes: action.payload }
            };
        case type.CANCEL_CHANGE:
            return { ...state, form: { ...defaultForm, allTypes: [...state.form.allTypes] } };
        case type.RESET_SELECT_THE_REPORT:
            return {
                ...state,
                form: { ...state.form, reportId: null }
            };
        case type.SELECT_THE_REPORT:
            return {
                ...state,
                form: {
                    ...state.form,
                    reportId: action.payload[0],
                    content: action.payload[1],
                    requester: action.payload[2],
                    provider: action.payload[3],
                    reported: action.payload[4],
                    images: action.payload[5],
                    type: action.payload[6],
                    locations: action.payload[7],
                    location_names: action.payload[8]
                }
            };
        case type.SELECT_LOCATIONS_INITIAL_DIALOG:
            return {
                ...state,
                form: {
                    ...state.form,
                    allLocations: action.payload
                }
            };
        case type.CLOSE_MODAL:
            return {
                ...state,
                form: { ...defaultForm },
                reports: []
            };
        default:
            return state;
    }
};
